function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function gfSetTeamsCookie(teams, exdays = 365) {
  try {
    const teamsArray = Array.isArray(teams) ? teams : [];
    const teamsString = teamsArray.join(',');

    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = 'all_teams=' + teamsString + ';' + expires + ';path=/';

    localStorage.setItem('user_favorite_teams', JSON.stringify({
      teams: teamsArray,
      lastUpdated: new Date().toISOString(),
      source: 'klaviyo_sync'
    }));

    console.log('Teams saved to both cookie and localStorage:', teamsArray);
    return true;
  } catch (error) {
    console.error('Error saving teams:', error);
    return false;
  }
}

function gfGetTeamsCookie() {
  try {
    const localData = localStorage.getItem('user_favorite_teams');
    if (localData) {
      const parsed = JSON.parse(localData);
      if (parsed.teams && Array.isArray(parsed.teams)) {
        console.log('Teams loaded from localStorage:', parsed.teams);
        return parsed.teams;
      }
    }

    let name = 'all_teams=';
    let decodedCookie = document.cookie;
    let ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        const teamsString = c.substring(name.length, c.length);
        const teams = teamsString ? teamsString.split(',').filter(team => team.trim()) : [];
        const normalizedTeams = teams.map(team => team.replace(/_/g, '-'));

        if (normalizedTeams.length > 0) {
          localStorage.setItem('user_favorite_teams', JSON.stringify({
            teams: normalizedTeams,
            lastUpdated: new Date().toISOString(),
            source: 'cookie_fallback'
          }));
        }

        console.log('Teams loaded from cookie:', normalizedTeams);
        return normalizedTeams;
      }
    }

    return null;
  } catch (error) {
    console.error('Error reading teams:', error);
    return null;
  }
}

function syncCustomerPreferencesToCookie() {
  if (!window.customer || !window.customer.email) return;

  const bootstrap = typeof window.__neCustomerPreferencesRead === 'function'
    ? window.__neCustomerPreferencesRead()
    : window.__customerPreferences;

  if (!bootstrap) return;


  const teams = (bootstrap.teams || []).filter(Boolean).map(team => team.replace(/_/g, '-'));
  const existing = gfGetTeamsCookie() || [];
  const sameTeams = JSON.stringify([...existing].sort()) === JSON.stringify([...teams].sort());

  if (!sameTeams) {
    gfSetTeamsCookie(teams);
  }
}


document.addEventListener('DOMContentLoaded', function() {
  syncCustomerPreferencesToCookie();
});

window.addEventListener('preferences-updated', function() {
  if (!window.customer || !window.customer.email) return;
  syncCustomerPreferencesToCookie();
});


function normalizeTeam(team_tag) {
  let team = team_tag;
  const upcaseNames = ['pga', 'liv', 'us', 'ac', 'bc', 'cf', 'fc', 'gc', 'sc', 'xi', 'xii', 'xiii', 'byu', 'la', 'lsu', 'wnba', 'mlb', 'nfl', 'nba', 'milb', 'nascar', 'rcr', 'tcu', 'usa', 'am', 'ucla', 'usc'];
  const replaceNames = [['4aces','4Aces'], ['a-frame','A-Frame'], ['hyflyers', 'HyFlyers'], ['mclaren','McLaren'],['rangegoats', 'RangeGoats'],['d.c.', 'D.C.'],['66ers', '66Ers'],['89ers', '89Ers'],['a&m','A&M']];
  const specialWords = ['fifty', 'forty', 'thirty', 'twenty'];

  team = team_tag?.toLowerCase().split(' ')?.map(word => {
    if (word === 'none') return '';

    const nameToReplace = replaceNames.find(name => word === name[0]);
    const upcaseName = upcaseNames.some(name => name === word);

    // Special case for numbers followed by special words like "fifty", "forty", etc.
    if (specialWords.some(specialWord => word.includes(specialWord))) {
      return word.toUpperCase();
    }

    if (nameToReplace) {
      return word.replace(nameToReplace[0], nameToReplace[1]);
    } else if (upcaseName) {
      return word.toUpperCase();
    } else {
      return word.charAt(0)?.toUpperCase() + word.slice(1);
    }
  })?.join(' ') || team_tag;

  return team;
}

function boldSilhouettes(){
  const regex = /\b(\d+)([a-zA-Z]{5,})\b/gi;

  const allElements = document.querySelectorAll('.product-card__product-title, h1, h2, h3, h4, h5, p, span')

  allElements.forEach(element => {
    const str = element.textContent
    if(element.childElementCount === 0){
      element.innerHTML = str.replace(regex, '<b>$1</b>$2')
    }
  })
}

function superscriptTrademarks(){
  const allElements = document.querySelectorAll('.product-card__product-title, h1, h2, h3, h4, h5, p, span')

  allElements.forEach(element => {
    if(element.classList.contains('filter-text')){
      return;
    }
    if(element.innerHTML.includes('\u00AE')){
      element.innerHTML = element.innerHTML.replace(/\u00AE/g, '<sup class="trademark">\u00AE</sup>')
    }
  })
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  if(!container || !elementToFocus) return;

  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');

  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => {
      summary.removeEventListener('click', this.onSummaryClick);
      summary.addEventListener('click', this.onSummaryClick.bind(this));
    });

    this.querySelectorAll('button').forEach(button => {
      button.removeEventListener('click', this.onCloseButtonClick);
      button.addEventListener('click', this.onCloseButtonClick.bind(this));
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      this.mainDetailsToggle.setAttribute('open', '');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {

        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {

        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('click', (event) => {
        if (event.target.classList.contains('product-media-modal__content')
          || event.target.classList.contains('product-media-modal') ) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    const autoplay = this.hasAttribute('data-autoplay');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent(!autoplay);
    trapFocus(this, this.querySelector(autoplay ? '[id^="ModalClose-"]' : '[role="dialog"]'));
    if (!autoplay) window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    if (this.hasAttribute('data-autoplay')) {
      this.querySelector('.template-popup')?.resetContent();
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalDialogHolidayDrops extends ModalDialog {
  constructor() {
    super();
  }

  show(opener) {
    super.show(opener);

    const holidayBanner = this.closest('.section-main-blog-holiday-drops');
    if (holidayBanner) {
      holidayBanner.classList.add('section-main-blog-holiday-drops--open');
    }
  }

  hide() {
    const holidayBanner = this.closest('.section-main-blog-holiday-drops');
    if (holidayBanner) {
      holidayBanner.classList.remove('section-main-blog-holiday-drops--open');
    }

    super.hide();
  }
}

customElements.define('modal-dialog-holiday-drops', ModalDialogHolidayDrops);

class ModalDialogHolidayDropsPopup extends ModalDialog {
  constructor() {
    super();
  }

  show(opener) {
    super.show(opener);

    const holidayDropsPopup = this.closest('.section-holiday-drops');
    if (holidayDropsPopup) {
      holidayDropsPopup.classList.add('section-holiday-drops--open');
    }
  }

  hide() {
    const holidayDropsPopup = this.closest('.section-holiday-drops');
    if (holidayDropsPopup) {
      holidayDropsPopup.classList.remove('section-holiday-drops--open');
    }

    super.hide();
  }
}

customElements.define('modal-dialog-holiday-drops-popup', ModalDialogHolidayDropsPopup);
class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }

  // Unload media to prevent late playback after closing and allow a fresh replay.
  resetContent() {
    this.querySelector('video, model-viewer, iframe')?.remove();
    this.removeAttribute('loaded');
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderDots = this.querySelectorAll('.slider-dots-container .slider-dots-wrapper div')

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.sliderDots.forEach(dot => {
      dot.addEventListener('click', this.onDotClick.bind(this));
    });
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  onDotClick(event){
    event.preventDefault();
    const prevSelectedStepNode = Array.from(this.sliderDots).filter(e => e?.getAttribute("aria-selected") == "true")[0];
    const prevSelectedStep = parseInt(prevSelectedStepNode?.getAttribute("aria-label"));
    const step = parseInt(event.target.ariaLabel);
    this.slideScrollPosition = prevSelectedStep < step ? this.slider.scrollLeft + ((step - prevSelectedStep) * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - ((prevSelectedStep - step) * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
    prevSelectedStepNode.setAttribute("aria-selected", "false");
    event.target.setAttribute("aria-selected", "true");
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      const hasIncompleteOptions = this.options.some((option) => !option);
      if (this.dataset.requireSizeSelection === 'true' && hasIncompleteOptions) {
        this.toggleAddButtonEvent(false, '', true, e.target);
      } else {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      }
    } else if (!this.currentVariant.available) {
      this.toggleAddButtonEvent(true, window.variantStrings.soldOut, true, e.target);
    } else {
      this.toggleAddButtonEvent(false, '', true, e.target);
    }

    if (this.currentVariant) {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    handleStickyCardButtonBehavior();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    const currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const presale = productForm?.querySelector('presale-selling-plan');
    if (currentVariant && typeof presale?.isVariantAvailable === 'function') {
      currentVariant.available = currentVariant.available && presale.isVariantAvailable(currentVariant.id);
    }

    this.currentVariant = currentVariant;
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery?.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent?.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);

    // Insert new media after title if there's a title
    const modalTitle = modalContent?.querySelector(".modal-title");
    if (modalTitle) {
      modalTitle.insertAdjacentElement('afterend', newMediaModal);
    } else {
      // Otherwise just add it to the top
      modalContent?.prepend(newMediaModal);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment, [data-product-form]`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButtonEvent(disable = true, text, modifyClass = true, target) {
    const productForm = target.closest('.product__info-container');
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) {
        addButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }


  /*  setUnavailable(e) {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
    }*/

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class VariantSelectsCustom extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.productForm = this.closest('addcart');

  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButtonEvent(true, window.variantStrings.unavailable, true, e.target);
    } else if (!this.currentVariant.available) {
      this.toggleAddButtonEvent(true, window.variantStrings.soldOut, true, e.target);
    } else {
      this.toggleAddButtonEvent(false, '', true, e.target);
    }

    if (this.currentVariant) {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery?.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent?.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);

    // Insert new media after title if there's a title
    const modalTitle = modalContent?.querySelector('.modal-title');
    if (modalTitle) {
      modalTitle.insertAdjacentElement('afterend', newMediaModal);
    } else {
      // Otherwise just add it to the top
      modalContent?.prepend(newMediaModal);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    // const productForm = this.closest('addcart');
    const input = this.productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
        // const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment, [data-product-form]`);
    // productForms.forEach((productForm) => {
    //   const input = productForm.querySelector('input[name="id"]');
    //   input.value = this.currentVariant.id;
    //   input.dispatchEvent(new Event('change', { bubbles: true }));
    // });
  }

  updatePickupAvailability() {
    const pickUpAvailability = this.productForm.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButtonEvent(disable = true, text, modifyClass = true, target) {
    const productForm = target.closest('.product__info-container');
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) {
        addButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings?.addToCart ?? 'Add to cart';
    }

    if (!modifyClass) return;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings?.addToCart ?? 'Add to cart';
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    let validJsonData = this.querySelector('[type="application/json"]')?.textContent;
    if( validJsonData == undefined ) {
      let productId = this.getAttribute('data-section');
      let topElement = this.closest('[data-teams="true"], [data-colors="true"]');
      validJsonData = topElement.querySelector(`[data-id="script-${productId}"]`).textContent;
    }
    this.variantData = this.variantData || JSON.parse(validJsonData);
    return this.variantData;
  }
}

customElements.define('variant-selects-custom', VariantSelectsCustom);

class VariantRadiosCustom extends VariantSelectsCustom {
  constructor() {
    super(new VariantSelectsCustom());
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }

  updateMasterId() {
    const fieldset = this.querySelector('fieldset[data-option-index]');
    const optionIndex = Number(fieldset?.dataset.optionIndex);
    const initialVariantId = Number(this.dataset.initialVariantId);

    if (!Number.isInteger(optionIndex) || !initialVariantId) {
      super.updateMasterId();
      return;
    }

    const variants = this.getVariantData();
    const initialVariant = variants.find((variant) => variant.id === initialVariantId);
    const selectedValue = this.options[0];
    this.currentVariant = variants.find((variant) =>
      variant.options.every((option, index) =>
        option === (index === optionIndex ? selectedValue : initialVariant?.options[index])
      )
    );
  }
}

customElements.define('variant-radios-custom', VariantRadiosCustom);

function parallaxAffect() {
  const parallax = document.querySelectorAll(".js-parallax");
  const parallaxBackground = document.querySelectorAll(".js-parallax-background");

  window.addEventListener("scroll", function () {
    let offset = window.pageYOffset;

    parallax.forEach(el => {
      let wrapper = el.closest('.js-parallax-wrapper')
      if (wrapper.getBoundingClientRect().top < 0) {
        el.style.top = -wrapper.getBoundingClientRect().top * 0.7 + "px";
      } else {
        el.style.top = 0
      }
    })

    parallaxBackground.forEach(el => {
      let wrapper = el.closest('.js-parallax-wrapper')
      if (wrapper.getBoundingClientRect().top < 0) {
        el.style.backgroundPositionY = -wrapper.getBoundingClientRect().top * 0.7 + "px";
      } else {
        el.style.backgroundPositionY = 0
      }
    })
  });
}

parallaxAffect();

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

setTimeout(() => {
  ['.cc-btn-accept-selected', '.cc-btn-accept-all', '.cc-allow'].forEach((btnClass) => {

    let ccBannerBtn = document.querySelector(btnClass);

    ccBannerBtn && ccBannerBtn.addEventListener('click', (e) => {
      setTimeout(() => {
        if (!getCookie('email_collection_popup')) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'YqPk3P']);
          setCookie('email_collection_popup', true, 30);
        }
      }, 3000);
    })
  });
}, 3000);

if (!getCookie('email_collection_popup') && getCookie('cookieconsent_status')) {
  setTimeout(() => {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'YqPk3P']);
    setCookie('email_collection_popup', true, 30);
  }, 3000);
}


const popupPill = document.querySelector('.global-pill');

if(popupPill) {
  const popupCloseButton = popupPill.querySelector('.global-pill__close');

  if (!getCookie('pill_popup_hide')) {
    popupCloseButton.addEventListener('click', (event) => {
      setCookie('pill_popup_hide', true, 30);
      popupPill.classList.add('hide');
    });
  } else {
    popupPill.classList.add('hide');
  }
}


class TabsComponent {
  constructor(settings) {
    this.holders = document.querySelectorAll('.custom-collection');
    this.wraps = document.querySelectorAll('.team-wrap');

    this.holders.forEach(holder => {
      const buttons = holder.querySelectorAll('[data-product-url]');

      buttons.forEach(button => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
    });

    this.wraps.forEach(wrap => {
      wrap.querySelector('[data-product-url]').dispatchEvent(new Event('click'));
    })
  }

  onButtonClick(event) {
    event.preventDefault();
    const elem = event.target;
    const elemUrl = elem.getAttribute('data-product-url');
    const holder = elem.closest('.custom-collection')
    const collectionHolder = holder.querySelector('.custom-collection-holder');
    const products = holder.querySelectorAll(`.custom-collection--product`);
    const activeProduct = holder.querySelector(`[data-product-holder=${elemUrl}]`);

    collectionHolder.classList.add('hide')

    products.forEach(product => {
      product.classList.remove('active')
    });

    activeProduct.classList.add('active')
  }
}

const tabsSection = new TabsComponent();


class ProductVariantSwatcher {

  constructor() {
    this.setOptionDisabledCard();
  }

  setOptionDisabledCard() {
    const productCards = document.querySelectorAll('.custom-collection--product');


    productCards.forEach((productCard) => {
      let productCardVariantAvailable = productCard.querySelectorAll('.variant-available');

      productCardVariantAvailable.forEach((item) => {

        const dataItem = item.getAttribute('data-value');
        const dataDisabledItem = item.getAttribute('data-disabled');
        const dataInputs = productCard.querySelectorAll(`[data-value-input]`);

        dataInputs.forEach((dataInput) => {
          const info = dataInput.getAttribute('data-value-input');
          if(info == dataItem && dataDisabledItem == 'true') {
            dataInput.classList.add("disabled");
          }
        });
      });
    });
  }
}

const productVariant = new ProductVariantSwatcher();


const parallaxContainer = document.querySelectorAll(".collection-card");
if(parallaxContainer.length > 0) {
  parallaxContainer.forEach((container) => {
    container.addEventListener("mousemove", () => parallax(event, container));

    function parallax(event, container) {
      const shift = container.querySelector('.collection-card__image');
      const position = 5;
      const x = (window.innerWidth * 1.1 - event.pageX * position * 0.2) / 90;
      const y = (window.innerHeight * 1.1 - event.pageY * position * 0.2) / 90;
      shift.style.transform = `translateX(${x}px) translateY(${y}px)`;

      const bg = container.querySelector('.collection-card__bg-wrap');
      const bgX = ((window.innerWidth - event.pageX * position * 0.3) / 90) * (-1);
      const bgY = ((window.innerHeight - event.pageY * position * 0.3) / 90) * (-1);
      bg.style.transform = `translateX(${bgX}px) translateY(${bgY}px)`;
    }
  });
}

function checkPassword(e) {
  e.preventDefault();
  const form = e.target;
  const input = form.querySelector(`[name=password]`);
  const errorWrap = form.querySelector(`.page-password__error`);
  const passValue = document.querySelector(`.pass-param`).textContent;
  const encoded = window.btoa(passValue);

  input.addEventListener('input', (event) => {
    errorWrap.classList.add('visually-hidden');
  });

  if (input.value == window.atob(encoded)) {
    const collectionContent = document.querySelector(".product-grid-and-filter");
    if(collectionContent) {
      collectionContent.classList.remove('product-grid__hide')
      form.classList.add('visually-hidden');
      setCookie('showProtectContent', true, 10);
    }

    const productContent = document.querySelector(".product__wrapper");
    if(productContent) {
      productContent.classList.remove('product-wrapper__hide')
      form.classList.add('visually-hidden');
      setCookie('showProtectContent', true, 10);
    }

    const pageContent = document.querySelector(".page-wrapper__hide");
    if(pageContent) {
      pageContent.classList.remove('page-wrapper__hide')
      form.classList.add('visually-hidden');
      setCookie('showProtectContent', true, 10);
    }

  } else {
    errorWrap.classList.remove('visually-hidden');
  }

}

function removeFocusOnHover() {
  const elements = document.querySelectorAll('.header__icon, .megamenu__list-item, .link[aria-expanded="false"] span, .link[aria-expanded="false"] span, .carousel-product a');

  // Add a mouseover event listener to each element
  elements.forEach(element => {
      element.addEventListener('mouseover', () => {
          // If there's an element in focus, remove focus from it
          if(document.activeElement) {
              document.activeElement.blur();
          }
      });
  });
}
removeFocusOnHover();

function cookieTrigger() {
  const triggerBehavior = function(e) {
      e.preventDefault();
      e.stopPropagation();

      const button = document.querySelector('.osano-cm-window__widget');
      if (button) {
          button.click();
      }
  };

  const footerLinks = document.querySelectorAll('.footer-cookie-trigger');
  const openCookiePreferencesLinks = document.querySelectorAll('.open-cookie-preferences');
  const linkWithPrivacyTitle = document.querySelectorAll('a[title="Privacy Requests"]');

  footerLinks.forEach(link => {
      link.addEventListener('click', triggerBehavior);
  });

  openCookiePreferencesLinks.forEach(link => {
      link.addEventListener('click', triggerBehavior);
  });
  linkWithPrivacyTitle.forEach(link => {
      link.addEventListener('click', triggerBehavior);
  });
}
document.addEventListener("DOMContentLoaded", cookieTrigger);

const isProtectForm = document.querySelector(".js-form-password");
if(isProtectForm != null && isProtectForm.length > 0) {
  isProtectForm.classList.remove('visually-hidden');

  isProtectForm.addEventListener('submit', checkPassword);

  if(getCookie('showProtectContent')) {

    const collectionContent = document.querySelector(".product-grid-and-filter");
    if(collectionContent) {
      collectionContent.classList.remove('product-grid__hide')
      isProtectForm.classList.add('visually-hidden');
    }

    const productContent = document.querySelector(".product__wrapper");
    if(productContent) {
      productContent.classList.remove('product-wrapper__hide')
      isProtectForm.classList.add('visually-hidden');
    }

    const pageContent = document.querySelector(".page-wrapper");
    if(pageContent) {
      productContent.classList.remove('page-wrapper__hide')
      isProtectForm.classList.add('visually-hidden');
    }
  }
}

// Groups the dollar part only. Hoisted because constructing an
// Intl.NumberFormat is expensive and cart updates format several prices each.
const dollarGroupFormatter = new Intl.NumberFormat('en-US');

// `number` is an amount in cents; 0 and sub-$10 carts are valid and render "$0.00".
function formatToMoneyPrice(number) {
  if (typeof number !== 'number' || !isFinite(number) || number < 0) {
    return "Invalid input";
  }

  // Dollars and cents are split with integer arithmetic rather than dividing by
  // 100 up front, so no float error can reach the displayed amount.
  const cents = Math.round(number);
  const dollars = Math.floor(cents / 100);
  const remainder = String(cents % 100).padStart(2, '0');

  return `$${dollarGroupFormatter.format(dollars)}.${remainder}`;
}

class DateInput extends HTMLElement{
  constructor(){
    super()

    this.input = this.querySelector('#RegisterForm-birthday');
    this.hiddenBirthdayInput = this.querySelector('#RegisterForm-birthday-tag');
    this.customerBirthdayNote = this.querySelector('#RegisterForm-birthday-note')
    this.errorBox = this.querySelector('#RegisterForm-birthday-error');
    this.submitButton = this.parentElement.querySelector('button[type="submit"]');
    this.input.addEventListener('input', this.onInputChange.bind(this));
    this.submitButton.setAttribute('disabled', 'disabled')


    const maskOptions = {
      mask: Date,
      pattern: 'm/`d/`YYYY',
      autofix: 'pad'
    };
    IMask(this.input, maskOptions);
  }

  isOlderThanAge(date, minAge){
    const minAgeDate = new Date();
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    minAgeDate.setFullYear(today.getFullYear() - minAge);

    return date <= minAgeDate;
  };

  validateBirthDate(){
    const strings = window.themeStrings ?? {};
    const userInput = this.input.value.trim();
    const datePattern = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    if (!datePattern.test(userInput)) {
      return {
        valid: false,
        error: strings.birthdayInvalidFormat ?? 'Invalid date format. Please use MM/DD/YYYY.',
      };
    }
    const [month, day, year] = userInput.split('/').map(Number);
    const enteredDate = new Date(year, month - 1, day);
    if (enteredDate.getFullYear() !== year || enteredDate.getMonth() !== month - 1 || enteredDate.getDate() !== day) {
      return {
        valid: false,
        error: strings.birthdayInvalidDate ?? 'Invalid date. Please enter a valid date.',
      };
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (enteredDate > today) {
      return {
        valid: false,
        error: strings.birthdayFutureDate ?? 'The entered date cannot be in the future.',
      };
    }
    const isOlderThan13 = this.isOlderThanAge(enteredDate, 13);

    if (!isOlderThan13) {
      return {
        valid: false,
        error: strings.birthdayMinimumAge ?? 'Sorry, you must be at least 13 years old to create an account.',
      };
    }

    return {
      valid: true,
      error: 'Valid date',
    };
  };

  onInputChange(){
      const validation = this.validateBirthDate();
      if (validation.valid) {
        const [month, day, year] = this.input.value.trim().split('/').map(Number);
        const enteredDate = new Date(year, month - 1, day);
        const isOlderThan18 = this.isOlderThanAge(enteredDate, 18);

        this.hiddenBirthdayInput.value = `birthday:${this.input.value},legal_age:${isOlderThan18}`;
        this.customerBirthdayNote.value = this.input.value.replaceAll('/','-')
        this.errorBox.querySelector('span').innerText = '';
        this.errorBox.style.display = 'none';
        this.submitButton.removeAttribute('disabled');
        this.input.removeAttribute('aria-invalid');
        this.input.removeAttribute('aria-describedby');
      } else {
        this.errorBox.querySelector('span').innerText = validation.error;
        this.errorBox.style.display = 'block';
        this.submitButton.setAttribute('disabled', 'disabled');
        this.input.setAttribute('aria-invalid', 'true');
        this.input.setAttribute('aria-describedby', 'RegisterForm-password-error');
      }
    }
}

customElements.define('date-input', DateInput);
class ProductSiblings extends HTMLElement {
  constructor() {
    super();

    this.swatches = this.querySelectorAll('input[type=radio]');
    this.productSiblingsData = {};

    this.swatches?.forEach(swatch => {
      const handle = swatch.dataset.productHandle;
      this.prefetchProduct(handle);

      swatch.addEventListener('change', (e) => {
        this.selectedSibling = handle;
        this.updateProduct();
      });
    });
  }

  prefetchProduct(handle) {
    if (!this.productSiblingsData[handle]) {
      const searchParams = new URLSearchParams(window.location.search);
      const viewParam = searchParams.get('view');

      let fetchUrl = `/products/${handle}`;
      if (viewParam) {
        fetchUrl += `?view=${viewParam}`;
      }

      fetch(fetchUrl).then(res => res.text()).then(html => {
        this.productSiblingsData[handle] = new DOMParser().parseFromString(html, 'text/html').querySelector('.product__wrapper').innerHTML;
      });
    }
  }

  updateProduct() {
    if(!this.selectedSibling) return

    const searchParams = new URLSearchParams(window.location.search);
    const viewParam = searchParams.get('view');

    let fetchUrl = `/products/${this.selectedSibling}`;
    if (viewParam) {
      fetchUrl += `?view=${viewParam}`;
    }

    if (this.productSiblingsData[this.selectedSibling]) {
      document.querySelector('.product__wrapper').innerHTML = this.productSiblingsData[this.selectedSibling];
      this.updateURL();
    } else{
      fetch(fetchUrl).then(res => res.text()).then(html => {
        const newHtml =  new DOMParser().parseFromString(html, 'text/html')?.querySelector('.product__wrapper')?.innerHTML;
        document.querySelector('.product__wrapper').innerHTML = newHtml
        this.updateURL();
      })
    }
  }

  updateURL() {
    if (!this.selectedSibling) return;
    const searchParams = new URLSearchParams(window.location.search);
    const url = document.querySelector('.product__wrapper product-siblings')?.dataset.url;
console.log('url---', url)
    if (url) {
      const newUrl = `${url}?${searchParams.toString()}`;
      window.history.replaceState({}, '', newUrl);
    }
  }
}

customElements.define('product-siblings', ProductSiblings);

class ProductCard extends HTMLElement{
  constructor(){
    super()
    this.id = this.dataset?.productId
    this.handle = this.dataset?.productHandle
    this.title = this.dataset?.productTitle
    this.url = this.dataset?.productUrl


    this.querySelector('.product-card a')?.addEventListener('click', e => {
        e.preventDefault()

        Shopify?.analytics?.publish('product_clicked', {
          product: {
            id: +this.id,
            url: this.url,
            handle: this.handle,
            title: this.title
          }
        });
       Shopify?.analytics?.publish('product_image_clicked', {
          product: {
            id: +this.id,
            url: this.url,
            handle: this.handle,
            title: this.title
          }
        });
        window.location.href = this.url
      })
  }
}
customElements.define('product-card', ProductCard);

function formatMixedNumber(mixedNumber = ''){
  if (!mixedNumber) return '';

  const parts = mixedNumber.toString().trim().split(' ');

  if (parts.length === 2) {
      const wholeNumber = parts[0];
      const fraction = parts[1];

      if (fraction.includes('/')) {
          const [numerator, denominator] = fraction.split('/');
          const fracEntity = `&frac${numerator}${denominator};`;

          return {wholeNumber, fracEntity}
      }
  }
  return {wholeNumber: mixedNumber, fracEntity: ''};
}

class TeamNewsletterForm extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form');
    this.input = this.querySelector('input');
    this.button = this.querySelector('button');
    this.notification = this.querySelector('.team-newsletter__form_success')
    this.errorNotification = this.querySelector('.team-newsletter__form_error')

    this.input?.addEventListener('input', () => this.hideError());

    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const team = this.input?.dataset?.team;
      const teamName = this.input?.dataset?.teamName || team;
      const email = this.input?.value;
      if (!email || !team) return;

      this.button.classList.add('rotating');
      this.hideError();

      try {
        const bootstrap = typeof window.__neCustomerPreferencesRead === 'function'
          ? window.__neCustomerPreferencesRead()
          : (window.__customerPreferences || { email: '', teams: [] });
        const currentTeams = bootstrap.email === email ? (bootstrap.teams || []) : [];
        const teamAlreadyExists = currentTeams.map(t => t?.replaceAll('_', '-')).includes(team);
        if (!teamAlreadyExists) {
          await this.savePreferences(email, team, currentTeams);
          this.trackNewsletterSignup(team, teamName, 'plp');
          window?.TrueFansTracker?.trackTeamAdded(teamName, team, undefined, 'plp');
        } else {
          this.showNotification()
        }
      } catch (err) {
        console.error('Subscription failed:', err);
        this.showError(window.themeStrings?.somethingWentWrongTryAgain ?? 'Something went wrong. Please try again.');
      } finally {
        this.button.classList.remove('rotating');
      }
    });
  }

  trackNewsletterSignup(teamHandle, teamName, source) {
    try {
      const sessionId = localStorage.getItem('tf_session_id');
      if (!sessionId) return;
      fetch('https://true-fans-dashboard-hrcqeja3dbhjh5hs.eastus-01.azurewebsites.net/api/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event_type: 'team_newsletter_signup',
          session_id: sessionId,
          team_id: teamHandle,
          team_name: teamName,
          source: source || 'plp',
          page_url: window.location.href,
        }),
        keepalive: true,
      }).catch(() => {});
    } catch (_) {
      // Tracking must never affect the user-facing flow.
    }
  }

  async savePreferences(email, team, currentTeams = []) {
    const allTeams = [team, ...currentTeams.filter(t => t !== team)];

    const bootstrap = typeof window.__neCustomerPreferencesRead === 'function'
      ? window.__neCustomerPreferencesRead()
      : (window.__customerPreferences || { email: '', fits: [], silhouettes: [] });
    const preserveStyles = bootstrap.email === email;
    const properties = {
      all_teams: allTeams,
      teams: allTeams,
    };
    if (preserveStyles) {
      const fits = bootstrap.fits || [];
      const silhouettes = bootstrap.silhouettes || [];
      properties.styles = [
        ...fits.map(f => `fit_${f}`),
        ...silhouettes.map(s => `silhouettes_${s}`),
      ];
    }

    const saveOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        properties,
      }),
    };

    try {
      const response = await fetch('/apps/email_preferences', saveOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (typeof window.__neCustomerPreferencesCache === 'function' && window.customer?.email === email) {
        window.__neCustomerPreferencesCache({ teams: allTeams });
      } else {
        window.dispatchEvent(new CustomEvent('preferences-updated'));
      }
      this.showNotification()
      return data
    } catch (err) {
      console.error('Failed to save preferences:', err);
    }
  };

  showNotification() {
    if (this.notification) {
      this.form.style.display = 'none'
      this.notification.style.display = 'flex';
    }
  }

  showError(message) {
    if (!this.errorNotification) return;
    const span = this.errorNotification.querySelector('span');
    if (span) span.textContent = message;
    this.errorNotification.style.display = 'flex';
  }

  hideError() {
    if (!this.errorNotification) return;
    this.errorNotification.style.display = 'none';
  }
}
customElements.define('team-newsletter-form', TeamNewsletterForm);

class TeamsCarouselPills extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.teams-carousel-container');
    this.pillsContainer = this.querySelector('.teams-carousel-pills');
    this.pillsWrapper = this.querySelector('.teams-carousel-pills-container');

    this.init();
  }

  init() {
    this.loadViewedTeams();
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('teamsCookieUpdated', (event) => {
      if (event.detail.storageKey === 'viewedTeams') {
        this.loadViewedTeams();
      }
    });

    this.pillsContainer.addEventListener('scroll', () => {
      this.updateGradient();
    });

    new ResizeObserver(() => this.updateGradient()).observe(this.pillsContainer);
  }

  updateGradient() {
    const { scrollLeft, scrollWidth, clientWidth } = this.pillsContainer;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 5;
    const atStart = scrollLeft <= 5;
    this.pillsWrapper.classList.toggle('show-right', !atEnd);
    this.pillsWrapper.classList.toggle('show-left', !atStart);
  }

  loadViewedTeams() {
    try {
      const viewedTeams = localStorage.getItem('viewedTeams');

      if (viewedTeams) {
        const teams = JSON.parse(viewedTeams).slice(0, 10);
        this.renderTeams(teams);
      }

      if (!viewedTeams || JSON.parse(viewedTeams).length === 0) {
        this.hideCarousel();
      }
    } catch (e) {
      console.warn('Error loading viewed teams:', e);
      this.hideCarousel();
    }
  }

  renderTeams(teams) {
    this.pillsContainer.innerHTML = '';
    let logos = {};
    try {
      logos = JSON.parse(document.querySelector('script[data-logos-json]')?.textContent) || {};
    } catch (e) {
      logos = {};
    }

    teams.forEach((team) => {
      const logo = logos[team.handle.replaceAll('-', ' ')]
      const pill = this.createTeamPill(team,logo);
      this.pillsContainer.appendChild(pill);
    });
    this.container.style.display = 'flex';
  }

  formatTeamName(name) {
    const upperCaseWords = ['nhl', 'nfl', 'nba', 'mlb', 'mls', 'usa', 'wnba', 'ncaa', 'usc', 'lafc', 'nyc', 'fc'];
    return name
      .replace(/-/g, ' ')
      .replace(/\b\w+/g, (word) =>
        upperCaseWords.includes(word.toLowerCase())
          ? word.toUpperCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      );
  }

  createTeamPill(team,logo) {
    if(!team?.handle || !team.name){
      return
    }
    const displayName = this.formatTeamName(team.name);
    const pill = document.createElement('a');
    pill.className = 'team-pill';
    pill.href = `/collections/${team.handle}`;

    pill.innerHTML = `
    ${logo ? `<img src="${logo}" width="50" height="50" alt="${displayName} logo" loading="lazy">` : ''}
    <span class="ne-body-md">${displayName}</span>
    `
    return pill;
  }

  hideCarousel() {
    this.style.display = 'none';
  }
}

customElements.define('teams-carousel-pills', TeamsCarouselPills);
